import React from "react"

const NotFound = function(){
    return <h1>That page doesn't exist.</h1>
}

export default NotFound;